<template>
  <div v-loading.fullscreen.lock="pageLoading">
    <div class="header">
      <img id="logo" src="../assets/image/logo.png">
    </div>

    <main v-if="step === 1">
      <el-col
        :span="12"
        :offset="6"
        :xs="{ span: 18, offset: 3 }"
      >
        <p style="margin-top: 25px;">您上課的課程是：</p>

        <div class="classInfo">
          <p>{{ courseDate }}</p>
          <p>{{ titleDtl }}</p>
        </div>

        <el-form ref="form" :model="form" :rules="rules" size="small" :inline="true">
          <el-form-item v-if="successInfo.name_list.length > 0" prop="selectCheckName">
            <el-select
              v-model="form.selectCheckName"
              placeholder="選擇姓名"
            >
              <el-option
                v-for="item in successInfo.name_list"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="successInfo.name_list.length == 0" label="手機" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>

          <el-form-item style="text-align: center;">
            <el-button type="primary" style="background: #1a404c;font-size:18px;text-align:center;" @click="onSubmit">送出簽到</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </main>

    <main v-if="step === 2">
      <el-col
        :span="12"
        :offset="6"
        :xs="{ span: 18, offset: 3 }"
      >
        <br>
        <p v-if="false">小組: {{ successInfo.group_name }}</p>
        <p>姓名: {{ successInfo.name }}</p>

        <div class="classInfo" style="margin-bottom: 25px;">
          <p>{{ successInfo.success_message }}</p>
        </div>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <p style="margin-top: 0px;">【備註】</p>
        <p style="margin-top: 0px;color:red;">已簽到成功者請不要點擊「我要重填簽到」</p>
        <p style="margin-top: 0px;">我的簽到資訊有問題，請點擊按鈕:</p>
        <el-button type="primary" @click="reSignin">我要重填簽到(有問題時才需要使用)</el-button>
      </el-col>
    </main>

    <main v-if="step === 3">
      <el-col
        :span="12"
        :offset="6"
        :xs="{ span: 18, offset: 3 }"
      >
        <div class="classInfo error">
          <p>{{ errorMessage }}</p>
        </div>
      </el-col>
    </main>

    <!--C1現場報名-->
    <main v-if="step === 4">
      <el-col
        :span="12"
        :offset="6"
        :xs="{ span: 18, offset: 3 }"
      >
        <p style="margin-top: 25px;">您上課的課程是：</p>

        <div class="classInfo">
          <p>{{ courseDate }}</p>
          <p>{{ titleDtl }}</p>
        </div>

        <p style="margin-top: 25px;">請填寫報名資訊：</p>
        <br>

        <el-form ref="form" :model="form" :rules="rules" size="small" :inline="true">
          <el-form-item prop="selectcheckGroup">
            <el-select
              v-model="form.selectcheckGroup"
              placeholder="是否有參加小組"
            >
              <el-option
                v-for="item in checkGroup"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="form.selectcheckGroup" prop="groupType">
            <el-select
              v-model="form.groupType"
              placeholder="選擇組別"
              @change="onGroupTypeChange"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="form.selectcheckGroup" prop="districtName">
            <el-select
              v-model="form.districtName"
              placeholder="選擇牧區"
              @change="onDistrictChange"
            >
              <el-option
                v-for="item in districtOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="form.selectcheckGroup" prop="groupId">
            <el-select v-model="form.groupId" placeholder="選擇小組">
              <el-option
                v-for="item in groupOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name"></el-input>
          </el-form-item>

          <el-form-item style="text-align: center;">
            <el-button type="primary" style="background: #1a404c;font-size:18px;text-align:center;" @click="onSubmit">現場簽到</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </main>
  </div>
</template>

<script>
import {
  // postSigninPlagueCourse,
  getSigninPlagueCourse,
  fetchParishGroup,
  postSigninCourse
} from '../api/plaguecourse'

export default {
  name: 'PCourseSignin',
  data () {
    return {
      pageLoading: false,
      clcFormInfo: this.$cookie.get('clc_form_info') || '',
      step: '',
      checkGroup: [
        { label: '是', value: true },
        { label: '否', value: false }
      ],
      typeOptions: [],
      districts: [],
      groups: [],
      courseDate: '',
      titleDtl: '',
      courseDesc: '',
      errorMessage: '',
      form: {
        groupType: '',
        districtName: '',
        groupId: '',
        memberId: '',
        name: '',
        phone: '',
        is_selected_name: false,
        selectcheckGroup: '',
        selectCheckName: ''
      },
      rules: {
        groupType: [
          { required: true, message: '請選擇組別', trigger: 'change' }
        ],
        districtName: [
          { required: true, message: '請選擇牧區', trigger: 'change' }
        ],
        groupId: [
          { required: true, message: '請選擇小組', trigger: 'change' }
        ],
        name: [
          { required: true, message: '請填寫姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '請填寫手機', trigger: 'blur' }
          // {
          //   validator: (rule, value, callback) => {
          //     const isValid = /^(09)[0-9]{8}$/.test(value)
          //     return isValid ? callback() : callback(new Error('手機格式錯誤'))
          //   },
          //   trigger: 'blur'
          // }
        ],
        selectcheckGroup: [
          { required: true, message: '請選擇是否有參加小組', trigger: 'change' }
        ],
        selectCheckName: [
          { required: true, message: '請選擇姓名', trigger: 'change' }
        ]
      },
      successInfo: {
        name_list: []
      }
    }
  },
  computed: {
    districtOptions () {
      const groupMap = this.groups
        .filter(g => g.group_type_name === this.form.groupType)
        .reduce((acc, g) => {
          acc[g.district_name] = true
          return acc
        }, {})
      return Object.keys(groupMap).map(g => ({ label: g, value: g }))
    },
    groupOptions () {
      return this.groups
        .filter(g => g.district_name === this.form.districtName)
        .map(g => ({ label: `${g.group_id} ${g.group_name}`, value: g.group_id }))
    }
  },
  created () {
    // if (this.clcFormInfo) {
    //   this.postSigninCourse()
    // } else {
    //   this.getSigninPlagueCourse()
    // }

    this.getSigninPlagueCourse()
    this.fetchParishGroup()
  },
  methods: {
    onGroupTypeChange () {
      this.form.group_id = ''
      this.form.districtName = ''
    },
    onDistrictChange () {
      this.form.groupId = ''
    },
    fetchParishGroup () {
      fetchParishGroup({ belongs_to: this.$route.params.belongsTo })
        .then(({ content }) => {
          this.typeOptions = content.group_type.map(d => ({ label: d, value: d }))
          this.districts = content.district
          this.groups = content.group
        }).catch(err => {
          console.log(err)
        })
    },
    getSigninPlagueCourse () {
      this.pageLoading = true

      getSigninPlagueCourse({
        url_get_parameter: this.$route.params.belongsTo
      }).then(({ content, success, message }) => {
        if (success) {
          this.courseDate = content.course_date
          this.titleDtl = content.title_dtl
          this.courseDesc = content.course_desc
          this.step = 1
        } else {
          this.errorMessage = message
          this.step = 3
        }
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.pageLoading = false
      })
    },
    postSigninCourse () {
      if (this.successInfo.name_list.length > 0) {
        this.form.name = this.form.selectCheckName
      }

      this.pageLoading = true

      postSigninCourse({
        url_get_parameter: this.$route.params.belongsTo,
        clc_form_info: this.clcFormInfo,
        group_id: this.form.groupId,
        is_selected_name: this.form.is_selected_name,
        name: this.form.name,
        phone: this.form.phone,
        is_now_signin_c1: this.step === 4
      }).then(({ content, success, message }) => {
        if (success) {
          this.successInfo = content

          if (content.name_list.length > 1) {
            this.form.is_selected_name = true
            alert('請選擇您的姓名')
            return
          }

          if (content.is_now_signin_c1) {
            this.step = 4
          } else {
            this.step = 2
            let date = new Date()
            date.setDate(date.getDate() + 360)
            this.$cookie.set('clc_form_info', content.clc_form_info, { expires: date })
          }
        } else {
          this.errorMessage = message
          this.step = 3
          this.$cookie.delete('clc_form_info')
        }
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.pageLoading = false
      })
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.postSigninCourse()
        } else {
          return false
        }
      })
    },
    reSignin () {
      this.$cookie.delete('clc_form_info')
      location.reload()
    }
  }
}
</script>

<style scope>
  #logo {
    height: 100%;
  }

  .header {
    position: relative;
    padding: 5px 0;
    height: 50px;
    background-color: #1c404c;
    user-select: none;
    z-index: 1;
    text-align: center;
  }

  .desc {
    padding-top: 1rem;
    padding-bottom: 1rem;
    font-size: 12px;
  }

  .el-select {
    display: block;
  }

  .el-form--inline .el-form-item {
    display: flex;
    margin-right: 0;
  }

  .el-form--inline .el-form-item__content {
    flex: 1;
  }

  .classInfo {
    border: 2px solid #008088;
    background-color: #f2f2f2;
    color: #008088;
    text-align: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .classInfo.error {
    color: red;
    padding: 1rem;
  }

  .classInfo.fat {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .title {
    background-color: #008088;
    color: white;
    text-align: center;
    padding: .5em;
  }
  </style>
